const drillDownYTitle = 'Halo Rating';

export default drillDownYTitle;
